/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Selected_LabelInputs */



/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Timing_Sync_Selected_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_selected_label = /** @type {((inputs?: Timing_Sync_Selected_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Selected_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Избранные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionado")
	return /** @type {LocalizedString} */ ("Selected")
});